// A modal <dialog>: Escape and a click on the dimmed backdrop close it (a drag that starts inside the
// form doesn't count). Content is the page's own <form>, laid out with the .dlg/.foot classes.
import { useEffect, useRef, type ReactNode } from "react";

export function Modal({ open, onClose, id, children }: { open: boolean; onClose: () => void; id?: string; children: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  const downOnBackdrop = useRef(false);
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);
  return (
    <dialog
      id={id}
      ref={ref}
      onClose={onClose}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onMouseDown={(e) => {
        downOnBackdrop.current = e.target === ref.current;
      }}
      onClick={(e) => {
        if (e.target === ref.current && downOnBackdrop.current) onClose();
      }}
    >
      {open ? children : null}
    </dialog>
  );
}
